<template lang="html">
  <div>
    <template v-if="loading">
      <pl-spinner
        style="margin-left: auto; margin-right: auto; margin-top: 200px"
        class="x2 mt10"
      />
    </template>
    <template v-else>
      <div class="row col-xs no-padding no-margin justify-end">
        <pl-button
          v-if="hasAdminAdminPermission"
          class="remove-selected-users pl-ruby"
          style="display: inline-block"
          @click.native="
            selectedUsers.length > 1
              ? removeSelectedUsers()
              : removeUserFromTable(selectedUsers[0])
          "
          :disabled="selectedUsers.length < 1"
        >
          Remove Selected Users
        </pl-button>
      </div>
      <table v-if="usersToShow" class="users-table mt3 w-100">
        <thead>
          <tr class="row">
            <td v-if="hasAdminAdminPermission" class="col-xs-1 b">
              <pl-checkbox
                v-if="!show_trial_teachers"
                v-model="allSelected"
                @change="selectAll"
                class="col-xs-1"
              />
            </td>
            <td class="col-xs-2 b">Name</td>
            <td class="col-xs-2 b">Email</td>
            <td class="col-xs-1 b" style="padding-left: 7px">Role</td>
            <!-- <td class="col-xs-2 b">School</td> -->
            <!-- (ignore for now; will be done on #259) -->
            <td class="col-xs-2 b">School</td>
            <td class="col-xs-1 b">RTs</td>
            <td class="col-xs-1 b">Type</td>
            <td class="col-xs-2 b">Last Active</td>
            <td class="col-xs-1 b"></td>

            <td class="col-xs-1 b"></td>
          </tr>
        </thead>
        <tbody
          v-if="usersToShow.length > 0 && !loadingTable"
          id="admin-view-users-table"
          @scroll="$emit('scroll-on-table')"
        >
          <tr class="row" v-for="(user, index) in usersToShow" :key="index">
            <td class="col-xs-1">
              <pl-checkbox
                v-if="user.id !== getProfile.id"
                :id="user.id"
                v-model="user.selected"
                @change="checkAllSelected"
                class="col-xs-1"
              />
            </td>
            <td class="col-xs-2 flex items-center">
              <div
                @click="openUserDetails(user)"
                class="avatar-circle avatar-size mr2 clickable"
                :style="{
                  backgroundImage: 'url(' + user.avatar_url + ')',
                  'background-size': 'cover',
                  'background-position': 'center',
                }"
              ></div>
              <span
                v-if="user.role === 'teacher'"
                class="name-cell cursor-pointer truncate"
                @click="openUserDetails(user)"
                :title="user.name"
              >
                {{ user.name }}
              </span>
              <span
                v-else
                class="cursor-pointer truncate"
                @click="openUserDetails(user)"
                :title="user.name"
                >{{ user.name }}</span
              >
            </td>
            <td class="col-xs-2 email-cell" :title="user.email">
              {{ user.email }}
            </td>
            <td class="col-xs-1 no-padding">
              <span>{{ user.role }} </span>
            </td>
            <td class="col-xs-2">
              {{ user.school_name }}
            </td>
            <td class="col-xs-1">{{ user.rts_count }}</td>
            <td class="col-xs-1">{{ user.type }}</td>
            <td class="col-xs-1">{{ user.last_active }}</td>
            <template>
              <td
                class="col-xs-1"
                v-if="hasAdminAdminPermission && user.id !== getProfile.id"
              >
                <pl-menu :menuSize="3" direction="right">
                  <pl-button slot="menu_trigger" class="pl-icon">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </pl-button>
                  <ul menu-content>
                    <li
                      @click="removeUserFromTable(user)"
                      style="color: #e53935"
                    >
                      Remove User
                      <i style="color: #e53935" class="fas fa-trash-alt" />
                    </li>
                  </ul>
                </pl-menu>
              </td>
            </template>
          </tr>
        </tbody>

        <div
          v-else-if="usersToShow.length == 0"
          class="center-xs b no-users-style"
        >
          No Users.
        </div>
        <div
          class="flex center-xs middle-xs h-inherit"
          v-if="loadingTable"
          key="loading"
        >
          <pl-spinner />
        </div>
      </table>
      <dialog-delete-confirm
        v-if="show_remove_user_confirmation"
        @close="show_remove_user_confirmation = false"
        @actionConfirmed="removeUsersCallService"
        :subHeader="contentMessageToRemove"
        :header="headerToRemoveUsers"
      />
      <dialog-delete-teachers-confirm
        v-if="show_remove_teachers_confirmation"
        @close="show_remove_teachers_confirmation = false"
        @actionConfirmed="removeUsersCallService"
        :subHeader="contentMessageToRemove"
        :optionalText="headerToRemoveUsers"
        :teachersToRemove="teachersToRemove"
      />
      <user-details-modal
        v-if="userDetailsID"
        @close="userDetailsID = ''"
        :userId="userDetailsID"
        :userSchool="userSchool"
        :systemWide="true"
      />
    </template>
  </div>
</template>
<script>
  import userDetailsModal from 'features/admin/adminPortal/userDetailsModal/userDetailsModal';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';
  import dialogDeleteTeachersConfirm from 'components/dialogDeleteTeachersConfirm';

  export default {
    components: {
      dialogDeleteConfirm,
      userDetailsModal,
      dialogDeleteTeachersConfirm,
    },
    data() {
      return {
        allSelected: false,
        selectedUsers: [],
        usersToBeRemoved: [],
        userDetailsID: '',
        userDetails: {},
        show_remove_student_confirmation: false,
        show_remove_teachers_confirmation: false,
        show_remove_user_confirmation: false,
        show_trial_teachers: false,
        show_remove_confirmation: false,
        roles: ['teacher', 'student'],
        loadingUser: '',
        loadingTable: false,
        headerToRemoveUsers: 'Remove User',
        contentMessageToRemove:
          'This action will remove these users and their data from the organization. Deleted users can only be restored by adding them back to the organization.',
        teachersToRemove: [],
      };
    },
    props: {
      usersList: {
        type: Array,
        default: [],
      },
      loading: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
        'hasAdminAdminPermission',
        'getCurrentSchool',
        'getProfile',
      ]),
      usersToShow() {
        return this.show_trial_teachers ? this.trialTeachers : this.usersList;
      },
    },
    methods: {
      openUserDetails(user) {
        this.userDetailsID = user.id;
        this.userSchool = user.school_id;
      },
      selectAll() {
        const all_s = this.allSelected;
        //school admin can't remove himself
        let users = this.usersToShow.filter((u) => u.id !== this.getProfile.id);
        users.forEach((itm) => (itm.selected = all_s));
        // in here I just need how many users are selected
        this.selectedUsers = users.filter((itm) => itm.selected);
      },
      checkAllSelected() {
        this.allSelected = this.usersToShow.every((itm) => itm.selected);
        // in here I just need how many users are selected
        this.selectedUsers = this.usersToShow.filter((itm) => itm.selected);
      },
      async removeUserFromTable(user) {
        this.usersToBeRemoved = [user.id];
        this.headerToRemoveUsers = 'Remove User ' + user.name;
        const teacherID = [user.id];
        if (user.school_id !== null) {
          await adminServices
            .getCoursesByTeacher(user.school_id, teacherID)
            .then((teachers) => {
              this.teachersToRemove = teachers;
              this.teachersToRemove.forEach((teacher) => {
                teacher.courses.forEach((t) => {
                  t.teachers.unshift({ id: '', name: 'Stay with teacher' });
                });
              });
            });
        }
        if (user.role === 'teacher') {
          this.contentMessageToRemove =
            'This action will remove this teacher and data from the organization. Deleted users can only be restored by adding them back to the organization. You must also decide whether teacher courses will be removed from the school (they will stay with this teacher’s account) or reassigned to a different teacher.';
          this.show_remove_teachers_confirmation = true;
        } else {
          this.contentMessageToRemove =
            'This action will remove this user and data from the organization. Deleted users can only be restored by adding them back to the organization.';
          this.show_remove_user_confirmation = true;
        }
      },
      async removeSelectedUsers() {
        this.usersToBeRemoved = [
          ...this.selectedUsers.map((sel) => {
            return sel.id;
          }),
        ];

        const checkNumberOfSchools = this.selectedUsers.some(
          (user) => user.school_id !== this.selectedUsers[0].school_id
        );

        if (checkNumberOfSchools) {
          const toast = {
            type: 'Warning',
            message: 'You must select teachers from same school to remove!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
        } else {
          if (this.selectedUsers[0].school_id !== null) {
            const teachersSelected = this.selectedUsers.filter(
              (user) => user.role === 'teacher'
            );

            const teacherIDs = [
              ...teachersSelected.map((sel) => {
                return sel.id;
              }),
            ];
            const schoolID = this.selectedUsers[0].school_id;
            await adminServices
              .getCoursesByTeacher(schoolID, teacherIDs)
              .then((teachers) => {
                this.teachersToRemove = teachers;
                this.teachersToRemove.forEach((teacher) => {
                  teacher.courses.forEach((t) => {
                    t.teachers.unshift({ id: '', name: 'Stay with teacher' });
                  });
                });
              });

            this.headerToRemoveUsers =
              'Remove ' + this.usersToBeRemoved.length + ' Users';
            this.contentMessageToRemove =
              'This action will remove these users and their data from the organization. Deleted users can only be restored by adding them back to the organization.';

            if (this.teachersToRemove.length > 0) {
              this.contentMessageToRemove =
                'This action will remove ' +
                this.teachersToRemove.length +
                ' teacher(s) and their data from the organization. Deleted users can only be restored by adding them back to the organization. You must also decide whether teacher courses will be removed from the school (they will stay with this teacher’s account) or reassigned to a different teacher.';
              this.show_remove_teachers_confirmation = true;
            } else {
              this.show_remove_user_confirmation = true;
            }
          } else {
            this.show_remove_user_confirmation = true;
          }
        }
      },
      removeUsersCallService() {
        this.loadingTable = true;
        if (this.usersToBeRemoved.length > 0) {
          const payload = {
            users_ids: this.usersToBeRemoved,
          };
          adminServices
            .deleteUser(payload)
            .then(() => {
              EventBus.$emit(
                'remove-users-of-school-from-table',
                this.usersToBeRemoved
              );
              this.loadingTable = false;
              this.selectedUsers = [];
            })
            .catch((error) => {
              this.loadingTable = false;
              if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                EventBus.$emit('toast-msg', error.response.data.message);
              } else {
                EventBus.$emit('toast-msg', error);
              }
              console.error(error);
            });
        } else {
          EventBus.$emit('toast-msg', 'Something went wrong! Contact support.');
        }
      },
      cleanUsersTableEvent() {
        EventBus.$on('parlay-users-filter-changed', () => {
          this.usersToShow.map((itm) => {
            return (itm.selected = false);
          });
          this.usersToBeRemoved = [];
          this.allSelected = false;
          this.selectedUsers = [];
        });
      },
    },
    mounted() {
      this.cleanUsersTableEvent();
    },
    beforeDestroy() {
      EventBus.$off('parlay-users-filter-changed');
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .upgrade-btn
    color:#5FA95C
    border: 2px solid #5FA95C
    padding:10px
    cursor:pointer
  .users-table
    padding 0
    tbody
      display:block
      overflow-y: auto
      height: calc(100vh - 285px)
      padding: 10px 8px
      tr
        border: 2px solid #e6e7e7
        border-bottom: none;
        align-items: center
        &:last-child
          border-bottom: 2px solid #e6e7e7
    td
      padding 1rem
      &.pending
        color: pl-ruby
      &.name-cell
        color: #78BEC8
        text-decoration: underline
      &.email-cell
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
    thead tr
      padding: 0 10px;
      td
        padding: 0 1rem

  .no-users-style
    padding-top: 20px;

  .remove-selected-users{
    margin: 6px 0px;
  }

  .name-cell
    color: #78BEC8
    text-decoration: underline

  .avatar-size
    min-width: 40px
    min-height: 40px
    max-width: 40px
    max-height: 40px
</style>



// WEBPACK FOOTER //
// adminViewUsersTable.vue?1d26c336